export const build = {"tag":"v1.0.5","hash":"59560df4","time":"261009.1129"}